import { AfterViewInit, Component, Input, OnInit } from '@angular/core';
import { wait } from '../../../../../../submodules/common/util';

@Component({
  selector: 'app-jwplayer',
  templateUrl: './jwplayer.component.html',
  styleUrls: ['./jwplayer.component.scss']
})
export class JwplayerComponent implements OnInit, AfterViewInit {

  @Input() file: string;
  @Input() image: string;
  @Input() autostart: boolean;
  @Input() repeat: boolean;
  @Input() controls: boolean;
  @Input() seek: number;

  constructor(/*public elementRef: ElementRef,private renderer: Renderer2*/) { }

  ngOnInit() {
    jwplayer.key = 'O8uLOTVHLRiOLoZJ6qgPRJi0blQaVJ3xcVxG3vDTZQc=';
  }

  async ngAfterViewInit() {

    // Senza questo wait il div non viene trovato quando viene chiamato jwplayer('myplayer').setup
    await wait(1000)

    this._setup();

    /**
     * logiche per posizionarsi opportunamente nel video
     */
    if(this.seek){
      this._seek(this.seek);
    }

    //this.elementRef.nativeElement.classList.add('live');
    //this.renderer.setElementClass(this.elementRef, '.jw-flag-live', true);
    //this.renderer.addClass(this.elementRef.nativeElement, 'jw-flag-live');
  }

  public changeImage(image: string): void {
    this.image = image;
    this._setup();
   
  }

  private _setup(): void {
    jwplayer('myplayer').setup({
      "width": "100%",
      "aspectratio": "16:9",
      "playlist": [{
        "image": this.image,
        "sources": [
          {
            "default": false,
            "file": this.file,
            "image": this.image,
            "type": "mp4",//"hls",
            "label": "0",
            "preload": "metadata"
          }
        ]
      }],
      "skin": {
        "name": "myskin"
      },
      "analytics": {
        enabled: false
      },
      "primary": "html5",
      "hlshtml": true,
      "autostart": this.autostart,
      "repeat": this.repeat,
      "controls": this.controls
    });

    jwplayer('myplayer').on('seek', function (e) {
      console.log("on seek")
    });

    jwplayer('myplayer').on('play', function () {
      console.log("on play")
    });
  }

  private _seek(seconds):void{
    jwplayer('myplayer').seek(seconds);
    //jwplayer.getPlugin("display").hide();
  }
}
